// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TSendValidationCodeRequest,
  TSendValidationCodeModel,
  IMappers,
  TSendValidationCodeResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IPublicSendValidationCodeResponse } from '../../entities/PublicValidationCode/PublicSendValidationCodeResponse';
import type { IErrorResponseSchema } from '../../entities/swagger-generator/ErrorResponseSchema';

export function createSendValidationCodeModel(parameters: TSendValidationCodeRequest): TSendValidationCodeModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'sms',
    pathApi: '/v2/send-validation-code/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ISendValidationCodeOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TSendValidationCodeRequest;
}

export async function fetchSendValidationCode<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISendValidationCodeOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TSendValidationCodeResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createSendValidationCodeModel(parameters),
    config,
  )) as FetchResponse<TSendValidationCodeResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicSendValidationCodeResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TSendValidationCodeResponse>;
}
